import React, { ChangeEvent, memo } from 'react'
import { Box, makeStyles } from 'transfix-ui/core'
import { IPricingTypes } from 'types/graphqlTypes'
import { IShipperRate } from 'apps/rms/types/shipperRates'
import { TrueRatePlusFilledIcon } from 'transfix-icons'
import { Switch } from 'transfix-ui'

interface IPricingTypeProps {
  value: RecursivePartial<IShipperRate>
  onChange(change: RecursivePartial<IShipperRate>): void
  error?: string
}

const useStyles = makeStyles(theme => ({
  toggle: {
    paddingLeft: theme.spacing(3),
  },
}))

export const PricingType = memo<IPricingTypeProps>(({ onChange, value }) => {
  const pricingTypeHandler = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    onChange({
      pricingType: checked ? IPricingTypes.variable : IPricingTypes.fixed,
      volumeType: checked ? undefined : value.volumeType,
      volume: checked ? undefined : value.volume,
      equipment: checked ? undefined : value.equipment,
      rate: checked ? undefined : value.rate,
      minChargeRate: checked ? undefined : value.minChargeRate,
    })
  }

  const classes = useStyles()

  return (
    <Box className={classes.toggle}>
      <Switch
        label={
          <div>
            Variable - TrueRate+ <TrueRatePlusFilledIcon color='coolGray8' />
          </div>
        }
        onChange={pricingTypeHandler}
      />
    </Box>
  )
})
